import Introduction6Container from './introduction6'

export default Introduction6Container